import { render, staticRenderFns } from "./DomainDnsHover.vue?vue&type=template&id=4a9da54a&scoped=true&"
import script from "./DomainDnsHover.vue?vue&type=script&lang=ts&"
export * from "./DomainDnsHover.vue?vue&type=script&lang=ts&"
import style0 from "./DomainDnsHover.vue?vue&type=style&index=0&id=4a9da54a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9da54a",
  null
  
)

export default component.exports